import React from 'react';
import PropTypes from 'prop-types';
import posed from 'react-pose';

import ProductGroup from '../ProductGroup';
import ProductRow from '../ProductRow';

import styles from './styles.module.css';

const Recommendations = ({products, onQuantityChange, hostRef}) => {
    const groups = {};
    products.forEach((product) => {
        if(!groups[product.group])
            groups[product.group] = [];

        groups[product.group].push(product);
    });

    return (
        <div ref={hostRef} className={styles.container}>
            {Object.keys(groups).map((name) => (
                <ProductGroup
                    title={name}
                    description=""
                    key={name}
                >
                    {groups[name].map((product) => (
                        <ProductRow
                            asin={product.asin}
                            key={product.asin}
                            title={product.name}
                            description={product.description || ''}
                            price={product.price}
                            rating={4}
                            image={product.image}
                            quantity={product.amount}
                            onQuantityChange={onQuantityChange}
                            compatible
                            recommended={product.recommended}
                        />
                    ))}
                </ProductGroup>
            ))}
        </div>
    );
};

Recommendations.propTypes = {
    products: PropTypes.arrayOf(PropTypes.object).isRequired,
    onQuantityChange: PropTypes.func.isRequired,
    hostRef: PropTypes.func.isRequired,
};

const easeIn = [0.4, 0.0, 1, 1];
const easeOut = [0.0, 0.0, 0.2, 1];

export default posed(Recommendations)({
    preEnter: {
        y: 50,
        opacity: 0,
    },
    enter: {
        y: 0,
        opacity: 1,
        transition: {
            duration: 400,
            ease: easeOut,
        },
    },
    exit: {
        y: 50,
        opacity: 0,
        transition: {
            duration: 400,
            ease: easeIn,
        },
    },
});
